import { USAGE_STATEMENT_STATUS_FULL } from '@/modules/copay/entities/enums/usageStatement';
import { Colors } from '@/shared/entities/types';
import React from 'react';
import { Chip, ProgressLinear, Text } from 'vkit/lib/components';
import { Grid, Tooltip } from 'vkit/lib/context';

interface UsageStatementStatusProps {
  status: USAGE_STATEMENT_STATUS_FULL;
  processing?: boolean;
}

interface StatusConfig {
  color: Colors;
  description: string;
  label: string;
  percent: number;
}

export const UsageStatementStatus: React.FC<UsageStatementStatusProps> = ({
  status,
  processing,
}) => {
  const statusConfig = {
    [USAGE_STATEMENT_STATUS_FULL.ERROR]: {
      color: 'danger',
      label: 'Erro',
      percent: 0,
      description: 'Ocorreu um erro ao processar o arquivo.',
    },
    [USAGE_STATEMENT_STATUS_FULL.REFUSED]: {
      color: 'danger',
      label: 'Arquivo recusado',
      percent: 0,
      description:
        'O arquivo foi recusado e, por isso, o processo de coparticipação não foi iniciado.',
    },
    [USAGE_STATEMENT_STATUS_FULL.NOT_PROCESSED]: {
      color: 'light',
      label: 'Aguardando aprovação',
      percent: 20,
      description: 'Confira o arquivo e clique em “Aprovar” para iniciar a coparticipação.',
    },
    [USAGE_STATEMENT_STATUS_FULL.WAITING_DESCRIPTION]: {
      color: 'warning',
      label: 'Pendente',
      percent: 40,
      description: 'Arquivo pendente: adicione a descrição das coparticipações.',
    },
    [USAGE_STATEMENT_STATUS_FULL.WAITING_LABELING]: {
      color: 'info',
      label: 'Análise time de saúde',
      percent: 60,
      description: 'Rotulações pendentes com time de saúde.',
    },
    [USAGE_STATEMENT_STATUS_FULL.PROCESSED]: {
      color: 'colorDefault',
      label: 'Processado',
      percent: 80,
      description: 'O arquivo foi processado e está pronto para ser enviado para faturamento.',
    },
    [USAGE_STATEMENT_STATUS_FULL.FINISHED]: {
      color: 'success',
      label: 'Finalizado',
      percent: 100,
      description: 'Coparticipação finalizada com sucesso.',
    },
    [USAGE_STATEMENT_STATUS_FULL.PENDING]: {
      color: 'light',
      label: 'Aguardando verificação',
      percent: 100,
      description: 'Aguardando usuário verificar o arquivo de coparticipação.',
    },
  }[status] as StatusConfig;

  if (processing) {
    statusConfig.color = 'light';
    statusConfig.label = 'Processando';
    statusConfig.description =
      'Aguarde enquanto o arquivo estiver sendo processado, isso pode demorar alguns minutos.';
  }

  return statusConfig ? (
    <Tooltip title={statusConfig.description}>
      <div style={{ minWidth: '250px' }}>
        <Grid column gap={6} stretch>
          <Grid alignContent='justify' alignItems='center' stretch>
            <Chip
              label={statusConfig.label}
              rounded
              size='small'
              color={statusConfig.color}
              invertColor={statusConfig.color === 'colorDefault'}
            />

            <Text size='medium' color={statusConfig.color} value={`${statusConfig.percent}%`} />
          </Grid>

          <div style={{ width: '100%' }}>
            <ProgressLinear percent={`${statusConfig.percent}%`} color='colorDefault' />
          </div>
        </Grid>
      </div>
    </Tooltip>
  ) : null;
};
